export default __webpack_public_path__ + "static/media/dress7.81ca524f.jpeg";